import Helper from "./Helper";

class Cv {
  constructor() {
    this.cvsToggler = document.querySelectorAll('.lc-cv__toggle');
    this.cvsTogglerArray = Array.prototype.slice.call(this.cvsToggler);

    this.bindEvents();
  }

  bindEvents() {
    this.cvsTogglerArray.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        const parent = toggle.parentNode;
        const content = parent.querySelector('.lc-cv-content__bottom');

        // Toggle 'active' class on the toggler
        Helper.toggleClass(toggle,'active');

        // Toggle 'open' class on the parent
        Helper.toggleClass(parent,'open');

        // Toggle visibility of the content
        if (content) {
          Helper.slideToggle(content, 300); // Smooth transition for visibility
        }
      });
    });
  }
}

export default Cv;
